import { LocaleApi, LocaleResponse } from 'cmp-client-api';
import { LocaleServiceInterface } from './types/locale.service.interface';

export class LocaleService implements LocaleServiceInterface {
  private readonly service: LocaleApi;

  public constructor(service: LocaleApi) {
    this.service = service;
  }

  public async getLocale(): Promise<LocaleResponse> {
    return this.service.getUserLocale().then(({ data }) => data);
  }

  public async updateLocale(locale: string): Promise<void> {
    return this.service.updateUserLocale(undefined, { locale }).then(({ data }) => data);
  }
}
